// Static/initial Filigree positions for screens and subscreens.
// Filigree styles can be updated via the store (uiState), note store state feeds

import { FILIGREE_ROTATE_ANIM_BASE_DEGREES } from 'global'

// into a react-spring animation hook.
type RetType = (qIndex?: number) => { [key: string]: any }

export const getFiligreeStyles = (screen: string): RetType => {
  switch (screen) {
    case 'StartScreen':
      return () => ({
        opacity: 0.2,
        width: ['630px', null, '1020px', '1250px', '1450'],
      })
    case 'QuestionsScreen':
      return (qIndex: number = -1) => {
        // Styles (i.e positions) for questions by question index
        const qStyles = [
          {
            top: ['40px', '80px', '-400px', '-460px'],
            left: ['210px', null, '428px', '606px', '954px'],
            transform: ['rotate(28deg)', null, 'rotate(45deg)'],
            width: ['411px', '515px', '660px', '780px'],
            opacity: 0.3,
          },
          {
            bottom: ['-430px', null, '-210px', null, '-230px', '-280px'],
            left: ['-210px', null, '-10px', '-110px', '10px'],
            transform: ['rotate(40deg)', null, null, 'rotate(70deg)'],
            width: ['500px', null, null, '670px'],
            opacity: 0.2,
          },
          {
            bottom: ['-390px', null, '-210px'],
            left: ['-190px', '147px', '-10px'],
            transform: ['rotate(35deg)'],
            width: ['500px'],
            opacity: 0.3,
          },
        ]
        // Start rotating through styles when qIndex > qStyles
        return qStyles[qIndex % qStyles.length] || { display: 'none' }
      }
    case 'HandScreen':
      return () => ({
        top: ['-130px', null, '-30px', '-30px'],
        left: ['-70px', null, '80px', '20px', '120px'],
        width: ['520px', null, '500px'],
        opacity: 0.3,
        transform: `rotate(${FILIGREE_ROTATE_ANIM_BASE_DEGREES}deg)`,
      })
    case 'DigestScreen':
      return () => ({
        top: ['-130px', null, '-30px', '-30px'],
        left: ['-70px', null, '80px', '20px', '120px'],
        width: ['520px', null, '500px'],
        transform: `rotate(${FILIGREE_ROTATE_ANIM_BASE_DEGREES}deg)`,
        opacity: 1,
      })
    default:
      return () => ({ display: 'none' })
  }
}
